module.exports = __webpack_public_path__ + "static/media/browse-chapter-cross-link.4d4739cf.png";